import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import * as DatiRCP from '../DatiRCP';
import {
    BaseComponent,
    BottoneAPI,
    ChiamaAPI,
    DocumentHocComponent,
    PolizzaApprovazione,
    Tipo,
    Trad
} from '../components/';
import { Document, Page, pdfjs } from 'react-pdf';
import moment from 'moment';
import ChiamaWeb, { CChiamaWebParametri } from "../ChiamaWeb";

pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';

interface IRCPPolizzaRinnovoState {
    NumeroPagine: number;
    PaginaCorrente: number;
    URLPDF: string;
    Rotazione: any;
    StatoPolizza: string;
    TipoProdotto: string;
    TipoRamo: string;
    Polizza: string;
    Tipi: { [T: string]: Dati.TDictTipo };
    ListaPolizzaApprovazioneJSON: Glob.DatiJSON;
    in1: string;
    in1Abl: boolean;
    in2: string;
    in2Abl: boolean;
    in3: string;
    in3Abl: boolean;
    in4: string;
    in4Abl: boolean;
    ID_TipoPolizzaStato: string;
    ID_TipoProdotto: number;
    ID_Binder: number;
    ID_BinderCompagnia: number;
    Aggiorna: number;
    ID_AnagPOS: number;
    Motivazione: string;
    MotivazioneAnnullamento: string;
    DataEmissione?: Date;
    DataFine: Date;
    GiorniEmissione?: number;
    TipologiaAnnullamento: number;
    FirstName: string;
    LastName: string;
    DocType: string;
    DocNumber: string;
    Phone: string;
    Email: string;
    PolicyFileState: string;
    PolicyFileData: string;
    Intermediary: any;
    IgnoreDuplicates: boolean;
    RenewalsJSON: Glob.DatiJSON;
    Rinnovi: Dati.CRinnovo;
    PassatoEsercizio: number;
    isNuovoFatturato: boolean;
    isFirst: boolean;
    NuovoFatturatoInput: string;
    NuovoFatturatoError: string
}

export class RCPPolizzaRinnovo extends BaseComponent<Glob.IRouteGlobaleProps, IRCPPolizzaRinnovoState> {

    private _Loading = <img src="/images/loadingBig.gif" />;
    private _ID_Polizza: number = 0;
    private _ID_Anag: number = 0;
    private _Cifra1: string = "0";
    private _Cifra2: string = "0";
    private _RichiestaCasella: string = "";
    private _Frazionamento: Dati.TDictTipo = {};

    private _FileDIP: Glob.DatiJSON = "{}";

    constructor(props: any) {
        super(props);
        this.state = {
            NumeroPagine: 0,
            PaginaCorrente: 1,
            URLPDF: "",
            Rotazione: 0,
            StatoPolizza: "Preventivo di polizza",
            TipoProdotto: "",
            TipoRamo: "",
            Polizza: "",
            Tipi: {},
            ListaPolizzaApprovazioneJSON: "[]",
            in1: "",
            in1Abl: true,
            in2: "",
            in2Abl: true,
            in3: "",
            in3Abl: true,
            in4: "",
            in4Abl: true,
            ID_TipoPolizzaStato: "",
            ID_TipoProdotto: 0,
            ID_Binder: 0,
            ID_BinderCompagnia: 0,
            Aggiorna: 1,
            ID_AnagPOS: 0,
            Motivazione: "",
            MotivazioneAnnullamento: "",
            DataFine: moment().utc().toDate(),
            GiorniEmissione: 31,
            TipologiaAnnullamento: 1,
            FirstName: "",
            LastName: "",
            DocType: "",
            DocNumber: "",
            Phone: "",
            Email: "",
            PolicyFileState: "",
            PolicyFileData: "",
            Intermediary: undefined,
            IgnoreDuplicates: false,
            RenewalsJSON: "",
            Rinnovi: new Dati.CRinnovo(),
            PassatoEsercizio: 0,
            isNuovoFatturato: true,
            isFirst: false,
            NuovoFatturatoInput: "",
            NuovoFatturatoError: ""
        }
        this.OnDocumentLoad = this.OnDocumentLoad.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnErrore = this.OnErrore.bind(this);
        this.OnClickSalvaAggiornamento = this.OnClickSalvaAggiornamento.bind(this);
        this._ID_Anag = (this.props.match.params as any).ID_Anag;
        this._ID_Polizza = (this.props.match.params as any).ID_Polizza;
        this.PopolaFrazionamento();
    }

    componentDidMount() {
    }

    private PopolaFrazionamento() {
        this._Frazionamento = {};
        this._Frazionamento["1"] = new Dati.CTipo("4", "Quadrimestrale");
        this._Frazionamento["2"] = new Dati.CTipo("6", "Semestrale");
        this._Frazionamento["3"] = new Dati.CTipo("12", "Annuale");
    }

    private OnApiError = (error: Error) => {
        Glob.InfoModaleError(Trad.Trad("ERRORE"), error.message);
    };

    private DownloadPolicyFile() {
        let url: string = "/api/File/GetPolicyFile"; //URL DI BASE
        url += "?sessione=" + Glob.GetSessione().Sessione; //ID SESSIONE UTENTE
        url += "&idPolicy=" + this._ID_Polizza; //ID POLIZZA
        url += "&idTypeProduct=" + this.state.ID_TipoProdotto;//ID TIPO PRODOTTO
        url += "&idBinderCompany=" + this.state.ID_BinderCompagnia;//ID BINDER COMPAGNIA
        url += "&idTypePolicyState=" + this.state.ID_TipoPolizzaStato; //ID TIPO POLIZZASTATO
        url += "&isJson=true"; //Tipo di stampa JSON
        url += "&isFile=false"; //Non voglio il download del file ma solo il suo path completo

        const Param: CChiamaWebParametri = {
            URL: "/api/File/GetPolicyFile",
            Metodo: "POST",
            OnRis: (sender, data) => this.OnDownloadPolicyFile(sender, data),
            OnInvio: () => this.GetPolicyFileData(),
            OnErrore: (sender: ChiamaWeb, error: Error) => this.OnApiError(error)
        };
        new ChiamaWeb().Chiama(Param);
    }

    private OnDownloadPolicyFile(sender: ChiamaWeb, data: Dati.CDatiPolicyFile) {
        if (data.State != "" && data.State != undefined) {
            this.setState({
                PolicyFileData: data.Data,
                PolicyFileState: data.State,
                FirstName: data.FirstName,
                LastName: data.LastName,
                DocType: data.DocType,
                DocNumber: data.DocNumber,
                Phone: data.Phone,
                Email: data.Email,
                URLPDF: data.Link
            });
        }
        else {
            this.setState({
                PolicyFileData: data.Data,
                FirstName: data.FirstName,
                LastName: data.LastName,
                DocType: data.DocType,
                DocNumber: data.DocNumber,
                Phone: data.Phone,
                Email: data.Email,
                URLPDF: data.Link
            });
        }
    }

    private GetPolicyFileData(): any {
        let request = new Dati.CDatiRequestPolicyFile();
        request.ID_Anag = this._ID_Anag;
        request.ID_Polizza = this._ID_Polizza;
        request.ID_TipoProdotto = this.state.ID_TipoProdotto;
        request.ID_BinderCompagnia = this.state.ID_BinderCompagnia;

        const dataEmissione = this.state.DataEmissione
            ? new Date(this.state.DataEmissione)
            : new Date("2024-12-31T00:00:00");

        if (((dataEmissione > new Date("2025-01-01T00:00:00") && dataEmissione < new Date("2025-07-22T00:00:00")))
            && (this.state.ID_BinderCompagnia === 1090372 || this.state.ID_BinderCompagnia === 1130486 || this.state.ID_BinderCompagnia === 1181365)) {
            request.ID_BinderCompagnia = 1332231;
        }

        //else if ((dataEmissione > new Date("2025-07-22T00:00:00"))
        //    && (this.state.ID_BinderCompagnia === 1329950)) {
        //    request.ID_BinderCompagnia = 1388381;
        //}
        else if (dataEmissione > new Date("2025-07-22T00:00:00")) {
            if (this.state.ID_BinderCompagnia === 1361282) { request.ID_BinderCompagnia = 1388223; }
            else if (this.state.ID_BinderCompagnia === 1329950) { request.ID_BinderCompagnia = 1388381; }
        }

        request.ID_TipoPolizzaStato = this.state.ID_TipoPolizzaStato;

        return request;
    }

    private OnSendPolicyToSignature(): any {
        let request = new Dati.CDatiRequestDigitalSignature();

        request.PolicyFile = this.GetPolicyFileData();
        request.Polizza = this.state.Polizza;
        request.FirstName = this.state.FirstName;
        request.LastName = this.state.LastName;
        request.DocType = this.state.DocType;
        request.DocNumber = this.state.DocNumber;
        request.Phone = this.state.Phone;
        request.Email = this.state.Email;

        let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
        let PHONE_REGEXP = /^\+?[1-9]\d{1,14}$/;

        if (!request.FirstName || request.FirstName.length <= 3) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad("FirstName is not valid"));
            return null;
        }

        if (!request.LastName || request.LastName.length <= 3) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad("LastName is not valid"));
            return null;
        }

        if (!request.DocType || request.DocType.length <= 3 || !request.DocNumber || request.DocNumber.length <= 3) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad("Document is not valid"));
            return null;
        }

        if (!request.Email || request.Email.length <= 5 || !EMAIL_REGEXP.test(request.Email)) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad("Email is not valid"));
            return null;
        }

        if (!request.Phone || request.Phone.length < 9 || !PHONE_REGEXP.test(request.Phone)) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad("Phone is not valid"));
            return null;
        }

        if (!request.Phone.startsWith('+')) {
            request.Phone = '+39' + request.Phone;
        }
        return request;
    }

    private OnDocumentLoad(pagine: number): void {
        this.setState({ NumeroPagine: pagine });
    }

    public PdfViewer(): any {
        return <div className="kt-demo__preview kt-demo__preview--btn">
            <Document file={`data:application/pdf;base64,${this.state.PolicyFileData}`}
                onLoadSuccess={(p) => { this.OnDocumentLoad(p.numPages) }}
                onLoadError={console.error}
                loading={this._Loading}
                rotate={this.state.Rotazione}>
                <Page pageNumber={this.state.PaginaCorrente} width={window.innerHeight} />
            </Document>
        </div>
    }

    public OnPaginaAvanti(e: React.FormEvent<any>): void {
        e.preventDefault();
        if (this.state.PaginaCorrente < this.state.NumeroPagine) {
            this.setState({ PaginaCorrente: this.state.PaginaCorrente + 1 });
        }
    }

    public OnPaginaIndietro(e: React.FormEvent<any>): void {
        e.preventDefault();
        if (this.state.PaginaCorrente > 1) {
            this.setState({ PaginaCorrente: this.state.PaginaCorrente - 1 });
        }
    }

    public OnPaginaFine(e: React.FormEvent<any>): void {
        e.preventDefault();
        this.setState({ PaginaCorrente: this.state.NumeroPagine });
    }

    public OnPaginaInizio(e: React.FormEvent<any>): void {
        e.preventDefault();
        this.setState({ PaginaCorrente: 1 });
    }

    public OnRuota(e: React.FormEvent<any>): void {
        e.preventDefault();
        let rotate: number = this.state.Rotazione + 90;
        if (rotate >= 360) {
            rotate = 0;
        }
        this.setState({ Rotazione: rotate });
    }

    private static dataURItoBlob(dataURI: string) {
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        return new Blob([int8Array], { type: 'application/pdf' });
    }

    public OnPrint(e: React.FormEvent<any>): void {
        e.preventDefault();
        const blob = RCPPolizzaRinnovo.dataURItoBlob(this.state.PolicyFileData);
        const url = URL.createObjectURL(blob);

        window.open(url, '_blank');
    }

    private abilitaCampiCartaServizi(campo: string) {
        switch (campo) {
            case "1":
                this.setState({ in1Abl: false });
                break;
            case "2":
                this.setState({ in2Abl: false });
                break;
            case "3":
                this.setState({ in3Abl: false });
                break;
            case "4":
                this.setState({ in4Abl: false });
                break;
        }
    }

    private recuperaCifra(cifra: string): string {
        switch (cifra) {
            case "1":
                return this.state.in1;
            case "2":
                return this.state.in2;
            case "3":
                return this.state.in3;
            case "4":
                return this.state.in4;
            default:
                return "";
        }
    }

    private emettiURL(): string {
        //let URL: string = "/api/polizza/EmissioneCartaServiziRCP";
        let URL: string = "/api/renewals/ReleaseRenewalWithServiceCard";
        URL += "?idPolicy=" + this._ID_Polizza.toString();
        URL += "&num1=" + this.recuperaCifra(this._Cifra1);
        URL += "&num2=" + this.recuperaCifra(this._Cifra2);
        return URL;
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIDatoTipiInfo_Polizza, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (!dati.Errore) {
                let DatiPolizza: DatiRCP.RCPPolizza = new DatiRCP.RCPPolizza();
                DatiPolizza = JSON.parse(dati.Dato.DatiPolizza);
                let Polizze: DatiRCP.CProdotto[] = DatiPolizza.Polizze;
                let ID_Binder: number = 0;
                let ID_BinderCompagnia: number = 0;

                for (let x: number = 0; x < Polizze.length; x++) {
                    if (Polizze[x].GaranziaBase.Selezionata) {
                        ID_Binder = Polizze[x].ID_Binder;
                        ID_BinderCompagnia = Polizze[x].ID_BinderCompagnia;
                    }
                }

                if (dati.Tipi["RichiesteCartaServizi"].RichiestaCifra1 != undefined && dati.Tipi["RichiesteCartaServizi"].RichiestaCifra2 != undefined) {
                    this._Cifra1 = dati.Tipi["RichiesteCartaServizi"].RichiestaCifra1.Valore;
                    this._Cifra2 = dati.Tipi["RichiesteCartaServizi"].RichiestaCifra2.Valore;
                    this.abilitaCampiCartaServizi(this._Cifra1);
                    this.abilitaCampiCartaServizi(this._Cifra2);
                    this._RichiestaCasella = dati.Tipi["RichiesteCartaServizi"].RichiestaCasella.Valore;
                }
                const demissione = moment(dati.Dato.DataEmissione);
                const now = moment(moment.now());

                let Rinnovo: Dati.CRinnovo = new Dati.CRinnovo();
                if (dati.Dato.RenewalsJSON != undefined && dati.Dato.RenewalsJSON != "")
                    Rinnovo = JSON.parse(dati.Dato.RenewalsJSON);

                this.setState({
                    StatoPolizza: dati.Dato.StatoPolizza,
                    TipoProdotto: dati.Dato.TipoProdotto,
                    TipoRamo: dati.Dato.TipoRamo,
                    Polizza: dati.Dato.Polizza,
                    Tipi: dati.Tipi,
                    ListaPolizzaApprovazioneJSON: dati.Dato.ListaPolizzaApprovazioneJSON,
                    ID_TipoPolizzaStato: dati.Dato.ID_TipoPolizzaStato,
                    ID_TipoProdotto: dati.Dato.ID_TipoProdotto,
                    ID_Binder: ID_Binder,
                    ID_BinderCompagnia: ID_BinderCompagnia,
                    DataEmissione: dati.Dato.DataEmissione,
                    DataFine: dati.Dato.DataFine,
                    Intermediary: dati.Dato.Intermediary,
                    GiorniEmissione: now.diff(demissione, "days"),
                    RenewalsJSON: dati.Dato.RenewalsJSON === undefined ? "" : dati.Dato.RenewalsJSON,
                    Rinnovi: Rinnovo,
                    PassatoEsercizio: DatiPolizza.DatoRCPPolizza.PassatoEsercizio
                });
                this.DownloadPolicyFile();
            }
            else {
                Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
            }
        }
        return true;
    }

    private OnAggiornaListaApprovazione(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPI<Dati.CPolizzaApprovazioneBase>();
        Ingr.Dato.ID_Polizza = this._ID_Polizza;
        Ingr.Dato.ListaPolizzaApprovazioneJSON = this.state.ListaPolizzaApprovazioneJSON;
        return Ingr;
    }

    private OnClickSalvaAggiornamento(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.Trad("Stato aggiornato correttamente"));
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
        }
    }

    private OnInvioAnnullaPolizza(sender: BottoneAPI): any {
        //console.warn("STATE", this.state);
        //this.RegoleCheck(this.state);
        //return false;
        var Ingr = new Dati.CIngrAPI<Dati.CDatiPolizzaAnnullamento>();
        Ingr.Dato.ID_Polizza = this._ID_Polizza;
        Ingr.Dato.Note = this.state.MotivazioneAnnullamento;

        Ingr.Dato.TipologiaAnnullamento = this.state.TipologiaAnnullamento;
        return Ingr;
    }

    private OnClickAnnullaPolizza(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto) + (dati.ErrTesti.length > 0 ? " - " + dati.ErrTesti.join(", ") : ""));
        }
        else {
            this.setState({ StatoPolizza: Glob.Tipi_PS_AnnullataSEO, Polizza: dati.MessaggioTesto });
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
            Glob.InfoModaleSuccess("Info", Trad.Trad("Polizza annullata correttamente"));
        }
    }

    private OnClickEmetti(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto) + (dati.ErrTesti.length > 0 ? " - " + dati.ErrTesti.join(", ") : ""));
        }
        else {
            //let app = this.state.;
            this.setState({ StatoPolizza: Glob.Tipi_PS_Emessa, Polizza: dati.MessaggioTesto })
            //app.Dato.Polizza = dati.MessaggioTesto;
            //app.Dato.StatoPolizza = "Polizza emessa";
            //this.setState({ Dato: app });
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
            Glob.InfoModaleSuccess("Info", Trad.Trad("Polizza emessa correttamente"));
        }
    }

    private bloccoInput(blocco: boolean): string {
        if (blocco) {
            return " cartaservizibloccata";
        }
        else {
            return "";
        }
    }

    private OnClickConsolidaSottoscrittore(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Preventivo di polizza {1-S} sottoposto al sottoscrittore correttamente", [this._ID_Polizza]));
            this.setState({ ID_TipoPolizzaStato: Glob.Tipi_PS_ConsolidataSottoscrittore, Aggiorna: this.state.Aggiorna + 1 });
        }
    }

    private OnClickConsolidaRinnovo(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Polizza {1-S} sottoposto al sottoscrittore correttamente", [this._ID_Polizza]));
            this.setState({ ID_TipoPolizzaStato: Glob.Tipi_PS_InRinnovoConsolidata, Aggiorna: this.state.Aggiorna + 1 });
        }
    }

    private OnClickCreaNuovoPreventivo(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Preventivo {1-S} creato correttamente", [dati.MessaggioTesto]));
            this.props.history.replace("/RCPComparatore/" + dati.ID_Chiave);
        }
    }

    private OnEmettiQuietanza(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Quietanza emessa correttamente", [this._ID_Polizza]));
            this.setState({ ID_TipoPolizzaStato: Glob.Tipi_PS_EmessaRinnovata, Aggiorna: this.state.Aggiorna + 1 });
        }
    }

    private OnInvioSalvaPolizza(sender: BottoneAPI): any {
        return this.state.Rinnovi;
    }

    private OnClickCancel(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("POLIZZA"), Trad.TradParam("Preventivo cancellato correttamente con ID: {1-S}", [this._ID_Polizza]));
            this.props.history.push("/");
        }
    }

    private OnClickSendPolicyToSignature(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto) + (dati.ErrTesti.length > 0 ? " - " + dati.ErrTesti.join(", ") : ""));
        }
        else {
            this.setState({ PolicyFileState: Glob.Tipi_FS_Inviato })
            this.setState({ Aggiorna: this.state.Aggiorna + 1 });
            Glob.InfoModaleSuccess("Info", Trad.Trad("Richiesta per la firma digitale inviata correttamente"));
        }
    }

    private Print() {

        let URLCOMPLETO: string = Glob.StampaURL(); //URL DI BASE
        URLCOMPLETO += "?SessioneMyAr=" + Glob.GetSessione().Sessione; //ID SESSIONE UTENTE
        URLCOMPLETO += "&Chiave=" + this._ID_Polizza; //ID POLIZZA
        URLCOMPLETO += "&Database=" + Glob.StampaDatabase(); //Database da cui recuperare i dati per la stampa
        URLCOMPLETO += "&NomeFile=PolizzaRCP"; //Nome del file per il dowloand (non serve ma va passato)
        URLCOMPLETO += "&Tipo=JSON-Q-" + this.state.ID_BinderCompagnia + "-PDF"; //Tipo di template word di stampa da utilizzare
        URLCOMPLETO += "&JSON=true"; //Tipo di stampa JSON
        URLCOMPLETO += "&File=true"; //Non voglio il download del file ma solo il suo path completo

        window.open(URLCOMPLETO, "_blank", "location=yes,height=600,width=800,scrollbars=yes,status=yes");
        Glob.Log(Glob.LogCat.Stampa, false, URL + "-O");

    }

    public render() {
        var content: any;
        var maxGiorniAnnullamento = 0;
        const gruppi = Glob.GetSessione().Gruppi;

        let isUnderwriter: boolean = false;
        if (gruppi.indexOf("G&T") != -1 || gruppi.indexOf("16") != -1)
            isUnderwriter = true;

        if (gruppi.length > 0) {
            if (gruppi.indexOf("9") != -1)
                //junior 7 giorni
                maxGiorniAnnullamento = 7;
            else
                if (gruppi.indexOf("8") != -1 || gruppi.indexOf("7") != -1)
                    maxGiorniAnnullamento = 100;
                else
                    if (gruppi.indexOf("G&T") != -1 || gruppi.indexOf("16") != -1)
                        maxGiorniAnnullamento = 100;
        }
        //maxGiorniAnnullamento=100;
        if (this.state.URLPDF == "") {
            content = this._Loading;
        } else {
            content = this.PdfViewer();
        }

        let approvatore: boolean = false;
        let ListaApprovazioni: Dati.CPolizzaApprovazione[] = JSON.parse(this.state.ListaPolizzaApprovazioneJSON);

        let isMeMmal: boolean = false;
        /*isMeMmal = ((this.state.ID_TipoProdotto >= 26 && this.state.ID_TipoProdotto <= 29) || this.state.ID_TipoProdotto == 50);*/

        const mammalIds = [26, 27, 28, 29, 50, 128, 129, 132, 133, 134, 147];
        isMeMmal = mammalIds.includes(this.state.ID_TipoProdotto);



        const statiBloccati = [
            Glob.Tipi_PS_EmessaRinnovata,
            Glob.Tipi_PS_EmessaRinnovataQ,
            Glob.Tipi_PS_InRinnovoApprovata
        ];

        if (!statiBloccati.includes(this.state.ID_TipoPolizzaStato)) {
            if (this.state.Rinnovi.Domanda2 && !this.state.isNuovoFatturato) {
                Glob.InfoModaleSuccess("Errore", Trad.Trad("Aggiornare il fatturato"));
            }
        }

        let Rinnovo: Dati.CRinnovo = new Dati.CRinnovo()
        //if (this.state.RenewalsJSON != "")
        Rinnovo = this.state.Rinnovi;
        /*        if (this.state.RinnoviJSON != "")
                    Rinnovo = JSON.parse(this.state.RinnoviJSON);*/

        // let PassatoEsercizio: number = Dati.CDatiPolizza.

        for (let i: number = 0; i < Glob.GetSessione().Gruppi.length; i++) {
            if (ListaApprovazioni.findIndex(a => a.CommentiGruppi[Glob.GetSessione().Gruppi[i]] != undefined) >= 0)
                approvatore = true;
        }
        console.log(Glob.GetSessione().Gruppi);
        let ParametriAssociaPolizzaAPOS: { [Param: string]: any } = [];
        ParametriAssociaPolizzaAPOS["id_Polizza"] = this._ID_Polizza * 1;
        ParametriAssociaPolizzaAPOS["id_AnagPOS"] = this.state.ID_AnagPOS * 1;
        ParametriAssociaPolizzaAPOS["motivazione"] = this.state.Motivazione;

        let Permesso_PS_Consolidata: string[];
        if (this.state.Tipi != undefined && this.state.Tipi.PolizzaStato != undefined && this.state.Tipi.PolizzaStato[Glob.Tipi_PS_Consolidata] != undefined)
            Permesso_PS_Consolidata = this.state.Tipi.PolizzaStato[Glob.Tipi_PS_Consolidata].Permesso || [];
        else
            Permesso_PS_Consolidata = [];


        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-glasses"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad(this.state.TipoRamo)} - {((Trad.Trad(this.state.TipoProdotto)).replace('- ACCELERANT', "")).replace('- MARKEL', "")} - {Trad.Trad(this.state.StatoPolizza)}
                        </h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                            <h4 className="kt-portlet__head-label">
                                {this.state.Polizza}
                            </h4>
                        </div>
                    </ul>
                </div>
            </div>
            <form className="kt-form login-form kt-form login-form--label-align-right kt-form login-form--state-" id="kt_form" noValidate>
                <div className="kt-portlet__body">
                    <div className="kt-section">
                        <span className="kt-section__heading text-center">
                            <div className="divtabella">
                                <a href="#" className="btn btn-success kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnPaginaInizio(e); }}>
                                    <i className="fa fa-fast-backward"></i>
                                </a>
                            </div>
                            <div className="divtabella">
                                <a href="#" className="btn btn-info kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnPaginaIndietro(e); }}>
                                    <i className="fa fa-chevron-left"></i>
                                </a>
                            </div><div className="divtabella">
                                <a href="#" className="btn btn-info kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnPaginaAvanti(e); }}>
                                    <i className="fa fa-chevron-right"></i>
                                </a>
                            </div>
                            <div className="divtabella">
                                <a href="#" className="btn btn-success kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnPaginaFine(e); }}>
                                    <i className="fa fa-fast-forward"></i>
                                </a>
                            </div>
                            <div className="divtabella">
                                <a href="#" className="btn btn-metal kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnRuota(e); }}>
                                    <i className="fa fa-redo"></i>
                                </a>
                            </div>
                            <div className="divtabella">
                                {(this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovata || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovataQ)
                                    ? <a href="#" target="_new" className="btn btn-warning kt-btn kt-btn--icon btn--icon-only" onClick={(e) => { this.OnPrint(e); }}>
                                        <i className="fa fa-print"></i>
                                    </a>
                                    : <></>
                                }
                            </div>
                            <div className="divtabella">
                                {this.state.PaginaCorrente} / {this.state.NumeroPagine}
                            </div>
                        </span>
                        <div className="kt-section__content text-center">
                            <p id="kt_blockui_1_content text-center">
                                {content}
                            </p>
                            <PolizzaApprovazione Id="ListaPolizzaApprovazioneJSON" Name="ListaPolizzaApprovazioneJSON" Dati={this.state.ListaPolizzaApprovazioneJSON} TipiPolizzaApprovazione={this.state.Tipi["PolizzaApprovazione"]} OnChange={(e, v) => this.OnChange(e, v)} Visibile={Glob.GetSessione().Autorizzazioni['PolizzaApprovazioneCommenti'] > 0} />
                        </div>
                        <div className="kt-section__content text-left">
                            <div className="form-group kt-form login-form__group text-center row">
                                <div className={Glob.DimensioneCSS(12)}>
                                    <DocumentHocComponent Label={Trad.Trad("SetInformativo")}
                                        SpecialInformationEnabled={false}
                                        GetListURL={"/api/Document/GetBinderProductFile?id_BinderCompagnia=" + this.state.ID_BinderCompagnia + "&id_TipoProdotto=" + this.state.ID_TipoProdotto} />
                                </div>
                            </div>
                            <div className={"form-group kt-form login-form__group row"}>
                                <div className={Glob.DimensioneCSS(12)}>
                                    <div className="drop-document kt-portlet kt-portlet--height-fluid">
                                        <div className="kt-portlet__head">
                                            <div className="kt-portlet__head-label">
                                                <h3 className="kt-portlet__head-title">{Trad.Trad("Rinnovo")}</h3>
                                            </div>
                                        </div>
                                        <div className="kt-portlet__body">
                                            <div className="kt-widget4">

                                                <div className="row mb-3 pb-3" style={{ borderBottom: "1px dashed #ebedf2" }}>
                                                    <div className={Glob.DimensioneCSS(6)}>
                                                        {Trad.Trad("RinnovoDomanda1")}
                                                        <div className="kt-radio-list">
                                                            <div className="row ml-1">
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdo1Si" type="radio"
                                                                        disabled={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovata
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovataQ
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoApprovata}
                                                                        checked={this.state.Rinnovi.Domanda1} onClick={() => {
                                                                            Rinnovo.Domanda1 = true;
                                                                            this.setState({ Rinnovi: Rinnovo })
                                                                        }} />{Trad.Trad("Si")} <span />
                                                                </label>
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success ml-4">
                                                                    <input name="rdo1No" type="radio"
                                                                        disabled={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovata
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovataQ
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoApprovata}
                                                                        checked={!this.state.Rinnovi.Domanda1} onClick={() => {
                                                                            Rinnovo.Domanda1 = false;
                                                                            this.setState({ Rinnovi: Rinnovo })
                                                                        }} />{Trad.Trad("No")}<span />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {(this.state.Rinnovi.Domanda1) ?
                                                        <>
                                                            <div className={Glob.DimensioneCSS(6)}>
                                                                <label>{Trad.Trad("RinnovoNote1")}</label>
                                                                <textarea className="form-control"
                                                                    name="NoteQ1"
                                                                    disabled={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovata
                                                                        || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovataQ
                                                                        || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoApprovata}
                                                                    value={this.state.Rinnovi.NoteQ1}
                                                                    rows={3}
                                                                    onChange={(e) => {
                                                                        Rinnovo.NoteQ1 = e.currentTarget.value;
                                                                        this.setState({ Rinnovi: Rinnovo });
                                                                    }}
                                                                >
                                                                </textarea>
                                                            </div>
                                                        </>
                                                        : <div />
                                                    }
                                                </div>
                                                <div className="row mb-3 pb-3" style={{ borderBottom: "1px dashed #ebedf2" }}>
                                                    <div className={Glob.DimensioneCSS(6)}>
                                                        <i>Domanda non valida per le polizze MedMal (Dentisti, Sanitari non Medici, Medici e Veterinari).</i><br />
                                                        {Trad.Trad("RinnovoDomanda2")}
                                                        <div className="kt-radio-list">
                                                            <div className="row ml-1">
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdo2Si" type="radio"
                                                                        disabled={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovata
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovataQ
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoApprovata
                                                                            || isMeMmal}
                                                                        checked={this.state.Rinnovi.Domanda2} onClick={() => {
                                                                            Rinnovo.Domanda2 = true;
                                                                            Rinnovo.NuovoFatturatoInput = Rinnovo.NuovoFatturato == 0 ? "" : (Rinnovo.NuovoFatturato).toString();
                                                                            this.setState({
                                                                                Rinnovi: Rinnovo,
                                                                                isNuovoFatturato: Rinnovo.NuovoFatturatoInput != "" ? true : false,
                                                                                isFirst: true
                                                                            });
                                                                            this.setState({ Rinnovi: Rinnovo })
                                                                        }} />{Trad.Trad("Si")} <span />
                                                                </label>
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success ml-4">
                                                                    <input name="rdo2No" type="radio"
                                                                        disabled={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovata
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovataQ
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoApprovata
                                                                            || isMeMmal}
                                                                        checked={!this.state.Rinnovi.Domanda2} onClick={() => {
                                                                            Rinnovo.Domanda2 = false;
                                                                            this.setState({ Rinnovi: Rinnovo })
                                                                        }} />{Trad.Trad("No")}<span />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {(this.state.Rinnovi.Domanda2 && !isMeMmal) ?
                                                        <>
                                                            <div className="row ml-1">
                                                                <span style={{ width: 200 }}>
                                                                    <label>{Trad.Trad("NuovoFatturatoPassatoEsercizio")}</label>
                                                                    <input type="text"
                                                                        className="form-control kt-input"
                                                                        style={{ width: 200 }}
                                                                        name="NuovoFatturatoPassatoEsercizio"
                                                                        required={this.state.Rinnovi.Domanda2}
                                                                        disabled={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovata
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovataQ
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoApprovata}
                                                                        value={isNaN(this.state.Rinnovi.NuovoFatturato) || this.state.isFirst ? "" : this.state.Rinnovi.NuovoFatturato.toString()}
                                                                        onChange={(e) => {
                                                                            const value = e.currentTarget.value;
                                                                            Rinnovo.NuovoFatturato = parseInt(value, 10);
                                                                            Rinnovo.NuovoFatturatoInput = isNaN(Rinnovo.NuovoFatturato) ? "" : (Rinnovo.NuovoFatturato).toString();
                                                                            this.setState({
                                                                                Rinnovi: Rinnovo,
                                                                                isNuovoFatturato: Rinnovo.NuovoFatturatoInput != "" ? true : false,
                                                                                isFirst: false,
                                                                                NuovoFatturatoError: value == "" ? "Fatturato da aggiornare" : ""  // <--- gestione errore
                                                                            });
                                                                        }} />
                                                                </span>
                                                                <span style={{ width: 300, marginLeft: 50, marginTop: 30 }}>
                                                                    <label>{Trad.Trad("FatturatoPassatoEsercizio")}: {this.state.PassatoEsercizio}</label>
                                                                </span>
                                                            </div>
                                                            <div style={{ color: "red", marginTop: 5 }}>
                                                                {this.state.NuovoFatturatoError}
                                                            </div>

                                                        </>
                                                        : <div />
                                                    }
                                                </div>
                                                <div className="row mb-3 pb-3" style={{ borderBottom: "1px dashed #ebedf2" }}>
                                                    <div className={Glob.DimensioneCSS(6)}>
                                                        {Trad.Trad("RinnovoDomanda3")}
                                                        <div className="kt-radio-list">
                                                            <div className="row ml-1">
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdo3Si" type="radio"
                                                                        disabled={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovata
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovataQ
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoApprovata}
                                                                        checked={this.state.Rinnovi.Domanda3} onClick={() => {
                                                                            Rinnovo.Domanda3 = true;
                                                                            this.setState({ Rinnovi: Rinnovo })
                                                                        }} />{Trad.Trad("Si")} <span />
                                                                </label>
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success ml-4">
                                                                    <input name="rdo3No" type="radio"
                                                                        disabled={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovata
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovataQ
                                                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoApprovata}
                                                                        checked={!this.state.Rinnovi.Domanda3} onClick={() => {
                                                                            Rinnovo.Domanda3 = false;
                                                                            this.setState({ Rinnovi: Rinnovo })
                                                                        }} />{Trad.Trad("No")}<span />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {(this.state.Rinnovi.Domanda3) ?
                                                        <>
                                                            <div className={Glob.DimensioneCSS(6)}>
                                                                <label>{Trad.Trad("RinnovoNote3")}</label>
                                                                <textarea className="form-control"
                                                                    name="NoteQ3"
                                                                    disabled={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovata
                                                                        || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovataQ
                                                                        || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoApprovata}
                                                                    value={this.state.Rinnovi.NoteQ3}
                                                                    rows={3}
                                                                    onChange={(e) => {
                                                                        Rinnovo.NoteQ3 = e.currentTarget.value;
                                                                        this.setState({ Rinnovi: Rinnovo });
                                                                    }}
                                                                >
                                                                </textarea>
                                                            </div>
                                                        </>
                                                        : <div />
                                                    }
                                                </div>

                                                {isUnderwriter && (this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoConsolidata
                                                    || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoApprovata
                                                    || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovata
                                                    || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_EmessaRinnovataQ)

                                                    ?
                                                    <div className="row mb-3 pb-3" style={{ borderBottom: "1px dashed #ebedf2" }}>
                                                        <div className={Glob.DimensioneCSS(6)}>
                                                            <label>{Trad.Trad("Note")}</label>
                                                            <textarea className="form-control"
                                                                name="Note"
                                                                value={this.state.Rinnovi.Note}
                                                                rows={3}
                                                                onChange={(e) => {
                                                                    Rinnovo.Note = e.currentTarget.value;
                                                                    this.setState({ Rinnovi: Rinnovo });
                                                                }}
                                                            >
                                                            </textarea>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(6)}>
                                                        </div>
                                                    </div>
                                                    : <div />}


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={Glob.GetSessione().Autorizzazioni['AssociaPolizzaAPOS'] != 2 ? "hidden" : "form-group kt-form login-form__group row"}>
                                <div className={Glob.DimensioneCSS(12)}>
                                    <div className="drop-document kt-portlet kt-portlet--height-fluid">
                                        <div className="kt-portlet__head">
                                            <div className="kt-portlet__head-label">
                                                <h3 className="kt-portlet__head-title">{Trad.Trad("Operazioni")}</h3>
                                            </div>
                                        </div>
                                        <div className="kt-portlet__body">
                                            <div className="kt-widget4">


                                                <div className="row mb-3 pb-3" style={{ borderBottom: "1px dashed #ebedf2" }}>
                                                    <div className={Glob.DimensioneCSS(2)}>
                                                        {Trad.Trad("AssociaPolizzaAPOS")}
                                                    </div>
                                                    <div className={Glob.DimensioneCSS(4)}>
                                                        <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                                            Campo={"ID_AnagPOS"}
                                                            ID_Chiave={this.state.ID_AnagPOS}
                                                            OnAggiorna={(e, v) => {
                                                                this.OnChange(e, v)
                                                            }} TradValori LinkSelezione="/anagrafica/" />
                                                    </div>
                                                    <div className={Glob.DimensioneCSS(4)}>
                                                        <textarea className="form-control" name="Motivazione" value={this.state.Motivazione} rows={2} onChange={this.OnChange} />
                                                    </div>
                                                    <div className={Glob.DimensioneCSS(2)}>
                                                        <BottoneAPI Attivo={this.state.ID_TipoPolizzaStato != Glob.Tipi_PS_Emessa}
                                                            Alt={Trad.Trad("Associa")}
                                                            Icona="fa fa-exchange-alt"
                                                            Testo={Trad.Trad("Associa")}
                                                            ClasseAttivo="btn btn-warning"
                                                            ClasseAttesa="btn kt-btn btn-warning kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                            URL="/api/polizza/AssociaPolizzaAPOS"
                                                            Metodo="POST"
                                                            OnClick={(s, d) => this.OnClickSalvaAggiornamento(s, d)}
                                                            ParamURLLista={ParametriAssociaPolizzaAPOS} />
                                                    </div>
                                                </div>


                                                {/*                                                <div className="row mb-3 pb-3" style={{borderBottom: "1px dashed #ebedf2"}}>
                                                    <div className={Glob.DimensioneCSS(12)}>
                                                        {Trad.Trad("IgnoreDuplicates")}
                                                        <div className="kt-radio-list">
                                                            <div className="row ml-1">
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdoSi" type="radio"
                                                                           checked={this.state.IgnoreDuplicates} onClick={() => {
                                                                        this.setState({IgnoreDuplicates: true})
                                                                    }}/>{Trad.Trad("Si")} <span/>
                                                                </label>
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success ml-4">
                                                                    <input name="rdoNo" type="radio"
                                                                           checked={!this.state.IgnoreDuplicates} onClick={() => {
                                                                        this.setState({IgnoreDuplicates: false});
                                                                    }}/>{Trad.Trad("No")}<span/>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>*/}



                                                {(this.state.ID_TipoPolizzaStato == "PS-Emessa"
                                                    || this.state.ID_TipoPolizzaStato == "PS-EmessaFirmata"
                                                    || this.state.ID_TipoPolizzaStato == "PS-EmessaRinnovataQ")
                                                    && this.state.GiorniEmissione! < maxGiorniAnnullamento ?
                                                    <div className="row mb-3 pb-3" style={{ borderBottom: "1px dashed #ebedf2" }}>

                                                        <div className={Glob.DimensioneCSS(2)}>
                                                            {Trad.Trad("AnnullaPolizza")}
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(4)}>
                                                            <div className="kt-radio-list">
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdoStornoConImposte" type="radio" checked={this.state.TipologiaAnnullamento == 1} onClick={() => { this.setState({ TipologiaAnnullamento: 1 }) }} />{Trad.Trad("AnnullamentoSeo")}<span></span>
                                                                </label>
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdoStornoConImposte" type="radio" checked={this.state.TipologiaAnnullamento == 2} onClick={() => { this.setState({ TipologiaAnnullamento: 2 }) }} />{Trad.Trad("StornoConImposte")}<span></span>
                                                                </label>
                                                                <label className="kt-radio kt-radio--solid kt-radio--state-success">
                                                                    <input name="rdoStornoConImposte" type="radio" checked={this.state.TipologiaAnnullamento == 3} onClick={() => { this.setState({ TipologiaAnnullamento: 3 }) }} />{Trad.Trad("StornoSenzaImposte")}<span></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className={Glob.DimensioneCSS(4)}>
                                                            <textarea className="form-control"
                                                                name="Motivazione"
                                                                value={this.state.MotivazioneAnnullamento}
                                                                rows={2}
                                                                onChange={(e) => this.setState({ MotivazioneAnnullamento: e.currentTarget.value })}>

                                                            </textarea>
                                                        </div>

                                                        <div className={Glob.DimensioneCSS(2)}>
                                                            <BottoneAPI
                                                                Attivo={this.state.MotivazioneAnnullamento.trim() != ""} //{this._AbilitaModifica && this.ValidateForm()}
                                                                Alt={Trad.Trad("Procedi")}
                                                                Icona="fa fa-trash"
                                                                Testo={Trad.Trad("Procedi")}
                                                                ClasseAttivo="btn btn-brand"
                                                                ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                                URL="/api/polizza/annullapolizza"
                                                                Metodo="POST"
                                                                OnInvio={s => this.OnInvioAnnullaPolizza(s)}
                                                                OnClick={(s, d) => this.OnClickAnnullaPolizza(s, d)}
                                                                //OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                                                Visibile={this._Scrittura}

                                                            />
                                                        </div>
                                                    </div>
                                                    : <div />}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/*                            <div className={this.state.Intermediary == undefined ? "hidden" : "form-group kt-form login-form__group row"}>
                                <div className={Glob.DimensioneCSS(12)}>
                                    <div className="drop-document kt-portlet kt-portlet--height-fluid">
                                        <div className="kt-portlet__head">
                                            <div className="kt-portlet__head-label">
                                                <h3 className="kt-portlet__head-title">{Trad.Trad("Rete distributiva")}</h3>
                                            </div>
                                        </div>
                                        <div className="kt-portlet__body">
                                            <div className="kt-widget4">
                                                <label>{Trad.Trad("Nome del Intermediario")} : {this.state.Intermediary}</label>  
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>*/}

                            {(this.state.ID_TipoPolizzaStato == "PS-Emessa" || this.state.ID_TipoPolizzaStato == "PS-EmessaFirmata") ?
                                <div className="form-group kt-form login-form__group row">
                                    <div className={Glob.DimensioneCSS(12)}>
                                        <div className="drop-document kt-portlet kt-portlet--height-fluid">
                                            <div className="kt-portlet__body">
                                                <div className="kt-widget4">
                                                    <>
                                                        <div className="row ">
                                                            <div className={Glob.DimensioneCSS(2)}>
                                                                {Trad.Trad("FirmaDigitale")}<br /><br />
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <label>{Trad.Trad("Nome")}</label>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <label>{Trad.Trad("Cognome")}</label>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(2)} />
                                                        </div>
                                                        <div className="row ">
                                                            <div className={Glob.DimensioneCSS(2)}>
                                                                <label>{Trad.Trad("Il contraente/Legale rappresentante")}</label>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <input type="text"
                                                                    className="form-control"
                                                                    name="FirstName"
                                                                    value={this.state.FirstName}
                                                                    onChange={(e) => this.setState({ FirstName: e.currentTarget.value })}>
                                                                </input>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <input type="text"
                                                                    className="form-control"
                                                                    name="LastName"
                                                                    value={this.state.LastName}
                                                                    onChange={(e) => this.setState({ LastName: e.currentTarget.value })}>
                                                                </input>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(2)} />
                                                        </div>
                                                        <div className="row ">
                                                            <div className={Glob.DimensioneCSS(2)}>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <label>{Trad.Trad("Tipo Documento")}</label>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <label>{Trad.Trad("Numero documento")}</label>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(2)}>
                                                            </div>
                                                        </div>
                                                        <div className="row ">
                                                            <div className={Glob.DimensioneCSS(2)}>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <select className="form-control"
                                                                    name="DocType"
                                                                    value={this.state.DocType}
                                                                    onChange={(e) => this.setState({ DocType: e.currentTarget.value })}>
                                                                    <option value="" />
                                                                    <option value="F-Passaporto">{Trad.Trad("F-Passaporto")}</option>
                                                                    <option value="F-Patente">{Trad.Trad("F-Patente")}</option>
                                                                    <option value="F-CartaIdentita">{Trad.Trad("F-CartaIdentita")}</option>
                                                                </select>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <input type="text"
                                                                    className="form-control"
                                                                    name="DocNumber"
                                                                    value={this.state.DocNumber}
                                                                    onChange={(e) => this.setState({ DocNumber: e.currentTarget.value })}>
                                                                </input>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(2)}>
                                                            </div>
                                                        </div>
                                                        <div className="row ">
                                                            <div className={Glob.DimensioneCSS(2)}>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <label>{Trad.Trad("Cellulare")}</label>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <label>{Trad.Trad("Email")}</label>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(2)}>
                                                            </div>
                                                        </div>
                                                        <div className="row ">
                                                            <div className={Glob.DimensioneCSS(2)}>
                                                                <h3 className="kt-portlet__head-title">{Trad.Trad(this.state.PolicyFileState)}</h3>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <input type="text"
                                                                    className="form-control"
                                                                    name="Celullare"
                                                                    value={this.state.Phone}
                                                                    onChange={(e) => this.setState({ Phone: e.currentTarget.value })}>
                                                                </input>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(4)}>
                                                                <input type="text"
                                                                    className="form-control"
                                                                    name="Email"
                                                                    value={this.state.Email}
                                                                    onChange={(e) => this.setState({ Email: e.currentTarget.value })}>
                                                                </input>
                                                            </div>
                                                            <div className={Glob.DimensioneCSS(2)}>
                                                                <BottoneAPI
                                                                    Attivo={this.state.Phone.trim() != "" && this.state.Email.trim() != ""
                                                                        && this.state.PolicyFileState != Glob.Tipi_FS_Inviato
                                                                        && this.state.PolicyFileState != Glob.Tipi_FS_Firmato}
                                                                    Alt={Trad.Trad("Invia")}
                                                                    Icona="fa fa-pencil"
                                                                    Testo={Trad.Trad("Invia")}
                                                                    ClasseAttivo="btn btn-brand"
                                                                    ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                                                    URL={"/api/File/SignaturePolicy"}
                                                                    Metodo="POST"
                                                                    OnInvio={() => this.OnSendPolicyToSignature()}
                                                                    OnClick={(s, d) => this.OnClickSendPolicyToSignature(s, d)}
                                                                    Visibile={this._Scrittura}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : <div />
                            }
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__foot kt-portlet__foot--fit">
                    <div className="kt-form login-form__actions kt-form login-form__actions--left">
                        <div className="modal fade" id="kt_modal_6" role="dialog" aria-labelledby="modalCartaServizi">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="exampleModalLongTitle">{Trad.Trad("Carta Servizi")}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body col-lg-12">
                                        <div className="form-group kt-form login-form__group row">
                                            <div className={Glob.DimensioneCSS(4)}><button className="btn btn-brand" type="button" name="indice">{this._RichiestaCasella}</button></div>
                                            <div className={Glob.DimensioneCSS(2)}><input type="text" name="in1" value={this.state.in1} maxLength={1} className={"form-control text-center" + this.bloccoInput(this.state.in1Abl)} onChange={(e) => this.OnChange(e)} disabled={this.state.in1Abl} /></div>
                                            <div className={Glob.DimensioneCSS(2)}><input type="text" name="in2" value={this.state.in2} maxLength={1} className={"form-control text-center" + this.bloccoInput(this.state.in2Abl)} onChange={(e) => this.OnChange(e)} disabled={this.state.in2Abl} /></div>
                                            <div className={Glob.DimensioneCSS(2)}><input type="text" name="in3" value={this.state.in3} maxLength={1} className={"form-control text-center" + this.bloccoInput(this.state.in3Abl)} onChange={(e) => this.OnChange(e)} disabled={this.state.in3Abl} /></div>
                                            <div className={Glob.DimensioneCSS(2)}><input type="text" name="in4" value={this.state.in4} maxLength={1} className={"form-control text-center" + this.bloccoInput(this.state.in4Abl)} onChange={(e) => this.OnChange(e)} disabled={this.state.in4Abl} /></div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className={"btn btn-secondary " + this._VisibileScrittura} data-dismiss="modal">{Trad.Trad("Chiudi")}</button>
                                        <BottoneAPI Default
                                            Testo={Trad.Trad("Emetti")}
                                            URL={this.emettiURL()}
                                            Metodo="POST"
                                            OnInvio={(s) => this.OnInvioSalvaPolizza(s)}
                                            OnClick={(s, d) => this.OnEmettiQuietanza(s, d)}
                                            OnErrore={(s, e) => this.OnErrore(s, e)}
                                            DataDismiss="modal"
                                            Visibile={this._Scrittura} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-12 kt--align-left">

                                <div className="divtabella">
                                    <BottoneAPI Attivo={!(this.state.Rinnovi.Domanda2 && !this.state.isNuovoFatturato)} Alt={Trad.Trad("Consolida sottoscrittore")}
                                        Icona="fa fa-book-reader" Testo={Trad.Trad("Consolida sottoscrittore")}
                                        ClasseAttivo="btn btn-warning"
                                        ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                        URL={`/api/renewals/ConsolidateRenewal?idPolicy=${this._ID_Polizza}`}
                                        Metodo="POST"
                                        OnInvio={(s) => this.OnInvioSalvaPolizza(s)}
                                        OnClick={(s, d) => this.OnClickConsolidaRinnovo(s, d)}
                                        OnErrore={(s, e) => this.OnErrore(s, e)}
                                        Visibile={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovo}
                                        Nome="Consolida"
                                    />
                                </div>
                                <div className="divtabella">
                                    <BottoneAPI Attivo={true} Alt={Trad.Trad("Approvato dal sottoscrittore")}
                                        Icona="fa fa-book-reader" Testo={Trad.Trad("Approvato dal sottoscrittore")}
                                        ClasseAttivo="btn btn-warning"
                                        ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                        URL={`/api/renewals/ApproveRenewal?idPolicy=${this._ID_Polizza}`}
                                        Metodo="POST"
                                        OnInvio={(s) => this.OnInvioSalvaPolizza(s)}
                                        OnClick={(s, d) => this.OnClickConsolidaRinnovo(s, d)}
                                        OnErrore={(s, e) => this.OnErrore(s, e)}
                                        Visibile={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoConsolidata && isUnderwriter}
                                    />
                                </div>
                                <div className="divtabella">
                                    <BottoneAPI Attivo={true} Alt={Trad.Trad("Crea nuovo preventivo")}
                                        Icona="fa fa-book-reader" Testo={Trad.Trad("Crea nuovo preventivo")}
                                        ClasseAttivo="btn btn-warning"
                                        ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                        URL={`/api/renewals/CreateQuotationFromPolicy?idPolicy=${this._ID_Polizza}&idGroupType=2&endDate=${moment(this.state.DataFine).utc().add(-1, 'years').format()}`}
                                        Metodo="POST"
                                        OnInvio={(s) => this.OnInvioSalvaPolizza(s)}
                                        OnClick={(s, d) => this.OnClickCreaNuovoPreventivo(s, d)}
                                        OnErrore={(s, e) => this.OnErrore(s, e)}
                                        Visibile={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoConsolidata && isUnderwriter}
                                    />
                                </div>

                                <div className="divtabella" data-toggle="modal" data-target="#kt_modal_6">
                                    <button type="button"
                                        className={(this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoConsolidata)
                                            || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_InRinnovoApprovata
                                            || (this.state.ID_TipoPolizzaStato != Glob.Tipi_PS_EmessaRinnovata && this.state.ID_TipoPolizzaStato != Glob.Tipi_PS_EmessaRinnovataQ
                                                && !this.state.Rinnovi.Domanda1 && !this.state.Rinnovi.Domanda2 && !this.state.Rinnovi.Domanda3)
                                            ? "btn btn-success" : "btn btn-success hidden"}
                                        title={"Emetti"}>
                                        <span>
                                            <i className="fa fa-thumbs-up" />
                                            <span>{Trad.Trad("Emetti quietanza")}</span>
                                        </span>
                                    </button>
                                </div>

                                <div className="divtabella">
                                    <button type="button"
                                        className="btn btn-accent"
                                        onClick={() => this.Print()}
                                        title={Trad.Trad("Stampa")}
                                        hidden={this.state.ID_TipoPolizzaStato != Glob.Tipi_PS_EmessaRinnovataQ}
                                    >
                                        <span>
                                            <i className="fa fa-file-pdf"></i>
                                            <span> {Trad.Trad("Stampa")}</span>
                                        </span>
                                    </button>
                                </div>
                                <div className="divtabella">
                                    <BottoneAPI Attivo={true} Alt={Trad.Trad("Consolida sottoscrittore")}
                                        Icona="fa fa-book-reader" Testo={Trad.Trad("Consolida sottoscrittore")}
                                        ClasseAttivo="btn btn-warning"
                                        ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                        URL={"/api/polizza/ConsolidaPolizzaSottoscrittoreRCP?id_Polizza=" + this._ID_Polizza}
                                        Metodo="GET"
                                        OnClick={(s, d) => this.OnClickConsolidaSottoscrittore(s, d)}
                                        OnErrore={(s, e) => this.OnErrore(s, e)}
                                        Visibile={(this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Consolidata || this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Approvata)
                                            && Permesso_PS_Consolidata.indexOf(Glob.Tipi_PS_ConsolidataSottoscrittore) >= 0} />
                                </div>
                                <div className="divtabella">
                                    <BottoneAPI Alt={Trad.Trad("Salva")} Icona="fa fa-inbox"
                                        Testo={Trad.Trad("Salva")}
                                        ClasseAttivo={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Consolidata ? "btn btn-success" : "btn btn-success hidden"}
                                        ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                        URL="/api/polizza/AggiornaListaPolizzaApprovazioneJSON"
                                        Metodo="POST"
                                        OnInvio={(s) => this.OnAggiornaListaApprovazione(s)}
                                        OnClick={(s, d) => this.OnClickSalvaAggiornamento(s, d)}
                                        Visibile={this._Scrittura} />
                                </div>
                                <div className="divtabella" data-toggle="modal" data-target="#kt_modal_6">
                                    <button type="button"
                                        className={this.state.ID_TipoPolizzaStato == Glob.Tipi_PS_Approvata && !approvatore ? "btn btn-success" : "btn btn-success hidden"}
                                        title={"Emetti"}>
                                        <span>
                                            <i className="fa fa-thumbs-up" />
                                            <span>{Trad.Trad("Emetti")}</span>
                                        </span>
                                    </button>
                                </div>

                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-12 kt--align-left">
                                <div className="divtabella">
                                    <BottoneAPI Attivo={true} Alt={Trad.Trad("Cancella")} Icona="fa fa-times-circle"
                                        Testo={Trad.Trad("Cancella")} ClasseAttivo="btn btn-danger"
                                        ClasseAttesa="btn kt-btn btn-brand kt-btn--custom kt-spinner kt-spinner--light kt-spinner--center"
                                        URL={"/api/polizza/ChangeStateToDraft?id_Polizza=" + this._ID_Polizza + "&allRecords=true"}
                                        Metodo="POST"
                                        OnClick={(s, d) => this.OnClickCancel(s, d)}
                                        OnErrore={(s, e) => this.OnErrore(s, e)}
                                        Visibile={this._Scrittura && (this.state.ID_TipoPolizzaStato != Glob.Tipi_PS_EmessaRinnovataQ)} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <ChiamaAPI Aggiornare={this.state.Aggiorna} URL={"/api/polizza/?id_Polizza=" + this._ID_Polizza + "&id_AnagContraente=0"} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/RCPPolizzaRinnovo.tsx